module.exports = __webpack_public_path__ + "img/style_0_13.6fc7f37b.png";